<template>
	<AddNewSite :isCollaboration="false" />
</template>

<script>
	export default {
		name: "addSitePage",
		components: {
			AddNewSite: () => import(/* webpackChunkName: "siteList" */ "../../../../components/User/Sites/AddSites/AddNewSite")
		},
	};
</script>
